import React from 'react'
import { LibraryElementTypes } from '../../../enums/libraryElementTypes'
import LibraryElement from '../Sidebar/Library/LibraryElement'

type LayoutElementsLibraryProps = {
  addEntity: (type: LibraryElementTypes) => void
}

const LayoutElementsLibrary = ({ addEntity }: LayoutElementsLibraryProps) => {
  return (
    <div className="flex flex-wrap gap-5">
      <LibraryElement
        type={LibraryElementTypes.LibraryLayout_12}
        onClick={() => addEntity(LibraryElementTypes.LibraryLayout_12)}
      />
      <LibraryElement
        type={LibraryElementTypes.LibraryLayout_6_6}
        onClick={() => addEntity(LibraryElementTypes.LibraryLayout_6_6)}
      />
      <LibraryElement
        type={LibraryElementTypes.LibraryLayout_4_4_4}
        onClick={() => addEntity(LibraryElementTypes.LibraryLayout_4_4_4)}
      />
    </div>
  )
}

export default LayoutElementsLibrary
